import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import './ProfileDetailsInput.css';

interface ProfileDetailsInputProps {
  type: string;
  value: string;
  label: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  customStyle?: boolean;
  isEmail?: boolean; // New optional prop
  startIcon?: React.ReactNode;
  isIconPresent?: boolean;
}

// Extend TextFieldProps to include your custom props
const CustomInputField = styled(TextField, {
  shouldForwardProp: (prop) =>
    prop !== 'isEmail' && prop !== 'startIcon' && prop !== 'isIconPresent', // Prevent forwarding `isEmail` to the DOM
})<
  TextFieldProps & {
    isEmail?: boolean;
    startIcon?: React.ReactNode;
    isIconPresent?: boolean;
  }
>(({ theme, isEmail, startIcon, isIconPresent }) => ({
  height: '60px',
  color: isEmail ? '#808080' : 'white',
  marginBottom: '13px',
  borderColor: '#365F91',
  border: '1.4px solid transparent',
  background: `
    linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
  `,
  borderImageSlice: 1,
  borderRadius: '35px',
  '& .MuiInputBase-input': {
    paddingLeft: '46.5px',
    color: isEmail ? '#808080' : 'white',
  },
  '& .MuiInputLabel-root': {
    color: '#7D7D7D', // Label color
    left: '46.5px',
    transform: 'translate(0, +23px)', // Position the label beside the icon
  },
  '& .MuiInputLabel-shrink': {
    left: '46.5px', // Move label to top on focus
    color: '#7D7D7D',
    fontSize: '12px',
    transform: isIconPresent ? 'translate(10px, -1px)' : 'translate(0, -1px)',
    paddingTop: '8px', // Adjust position when focused
  },
  '& .MuiInputLabel-outlined.Mui-focused': {
    color: isEmail ? '#808080' : 'white',
  },
  '& .MuiFilledInput-root': {
    '&:before': {
      borderBottom: 'none', // Remove default underline
    },
    '&:after': {
      borderBottom: 'none', // Remove focus underline
    },
    '&.Mui-focused:after': {
      color: '#7D7D7D',
      borderBottom: 'none', // Disable blue focus underline
    },
  },
  '&::placeholder': {
    color: '#7D7D7D', // Placeholder text color
    opacity: 1, // Ensure the color is fully applied
  },
}));

const ProfileDetailsInput: React.FC<ProfileDetailsInputProps> = ({
  type,
  value,
  label,
  onChange,
  customStyle,
  isEmail, // New prop
  name,
  startIcon,
  ...props
}) => {
  const renderStartAdornment = () => {
    if (name === 'phone') {
      return <span className="phone-input-startAdornment">+1</span>;
    }
    if (startIcon) {
      return <span className="input-startAdornment">{startIcon}</span>;
    }
    return undefined;
  };

  return (
    <CustomInputField
      variant="filled"
      name={name}
      type={type}
      value={value}
      label={label}
      isEmail={isEmail} // Pass the new prop
      onChange={onChange}
      InputProps={{
        startAdornment: renderStartAdornment(), // Call the function to determine adornment
      }}
      // InputLabelProps={{
      //   shrink: true, // Ensure label moves when typing or when focused
      // }}
      {...props}
    />
  );
};

export default ProfileDetailsInput;
